/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seo_Home_TitleInputs */

const he_seo_home_title = /** @type {(inputs: Seo_Home_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pricedrop - מעקב מחירים KSP | היסטוריית מחירים והשוואה`)
};

const en_seo_home_title = /** @type {(inputs: Seo_Home_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pricedrop - KSP Price Tracker | Price History & Comparison`)
};

/**
* | output |
* | --- |
* | "Pricedrop - KSP Price Tracker \| Price History & Comparison" |
*
* @param {Seo_Home_TitleInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const seo_home_title = /** @type {((inputs?: Seo_Home_TitleInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Home_TitleInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_seo_home_title(inputs)
	return en_seo_home_title(inputs)
});